import React, { useEffect, useState, useContext } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { GlobalContext } from '../../Contexts/GlobalContext';
import useCustomerSettings from 'CustomHooks/useCustomerSettings';
import FormControl from '@material-ui/core/FormControl';
import FormHelperText from '@material-ui/core/FormHelperText';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import Button from '@material-ui/core/Button';
import CircularProgressWithLabel from './CircularProgressWithLabel';
import Typography from '@material-ui/core/Typography';
import useFetch from '../../CustomHooks/useFetch';
import useGuiTranslations from '../MultiLanguage/useGuiTranslations';
import { capitalizeFirstLetter } from '../../Util/StringFunctions';
import useGoogleAnalytics from '../../CustomHooks/useGoogleAnalytics';

export default function MultiLanguage2(props) {
    const globalContext = useContext(GlobalContext);
    const classes = useStyles();
    const [isMultiLangEnabled, setIsMultiLangEnabled] = useState(false);
    const [availableLanguages, setAvailableLanguages] = useState([]);
    const [defaultLanguage, setDefaultLanguage] = useState('en');
    const getCustomerSettingsHookResponse = useCustomerSettings();
    const [state, setState] = useState('multiLangDisabled');
    const [updateMultilangSettingsHookResponse, updateMultilangSettingsHook] = useFetch();
    const [translateGui] = useGuiTranslations();
    const setGAPath = useGoogleAnalytics();


    const languages = [
        { code: 'en', name: 'English' },
        { code: 'de', name: 'Deutsch' },
        { code: 'fr', name: 'Français' },
        { code: 'es', name: 'Español' },
        { code: 'zh', name: '中文 (Chinese)' },
        { code: 'ru', name: 'Русский (Russian)' },
        { code: 'ja', name: '日本語 (Japanese)' },
        { code: 'it', name: 'İtaliano' },
        { code: 'sv', name: 'Svenska' },
        { code: 'tr', name: 'Türkçe' },
    ];

    useEffect(
        () => {
            //GA
            setGAPath('/AdvancedSettings/Multi-language');

            //Breadcrumb
            globalContext.dispatchMethod(
                {
                    type: 'SET_MENU_LOCATION',
                    value: {
                        a: 8,
                        b: 81,
                    },
                }
            )
        }, []
    )

    useEffect(
        () => {
            if (!Array.isArray(getCustomerSettingsHookResponse)) {
                //console.log('here');
                setDefaultLanguage(getCustomerSettingsHookResponse.defaultLanguage)

                if (getCustomerSettingsHookResponse.multiLangEnabled == true) {
                    setIsMultiLangEnabled(true);
                    setState('multiLangEnabled');

                }

                if (getCustomerSettingsHookResponse.availableLanguages) {
                    setAvailableLanguages(getCustomerSettingsHookResponse.availableLanguages)
                }
            }
        }, [getCustomerSettingsHookResponse]
    )

    const checkBoxClicked = (langCode) => {
        let tempArr = availableLanguages;
        if (availableLanguages.filter(availableLanguage => availableLanguage == langCode).length == 0) {
            tempArr.push(langCode);
        }
        else {
            tempArr = availableLanguages.filter(availableLanguage => availableLanguage != langCode);
        }
        setAvailableLanguages([...tempArr]);
    }

    const sendToServer = () => {

        if (availableLanguages.length > 0) {
            globalContext.dispatchMethod({ type: 'SET_MESSAGE', value: { message: '...', showButton: false } });
            updateMultilangSettingsHook(
                {

                    url: '​/admin/customersettings/update-multilang-settings',
                    method: 'PUT',
                    postData: {
                        "multiLangEnabled": true,
                        "defaultLanguage": defaultLanguage,
                        "availableLanguages": availableLanguages,
                    },
                    addTokenHeader: true,
                }
            )
            setIsMultiLangEnabled(true);
        }
        else {
            globalContext.dispatchMethod({ type: 'SET_MESSAGE', value: { message: 'Select at least one target language.', showButton: true } });
        }


    }

    const disableMultiLang = () => {
        globalContext.dispatchMethod({ type: 'SET_MESSAGE', value: { message: 'Disabling Multi-language...', showButton: false } });
        updateMultilangSettingsHook(
            {

                url: '​/admin/customersettings/update-multilang-settings',
                method: 'PUT',
                postData: {
                    "multiLangEnabled": false,
                    "defaultLanguage": defaultLanguage,
                    "availableLanguages": [],
                },
                addTokenHeader: true,
            }
        )
        setIsMultiLangEnabled(false);
    }

    return (
        <div className={classes.root}>

            {
                !isMultiLangEnabled ?
                    <div className={classes.marginBottom}>
                        {capitalizeFirstLetter(translateGui(87))}
                    </div>
                    : null
            }
            {
                isMultiLangEnabled ?
                    <div className={classes.marginBottom}>
                        {capitalizeFirstLetter(translateGui(92))}
                    </div>
                    : null
            }


            <div className={classes.flexColumn}>
                {capitalizeFirstLetter(translateGui(88))}
                <FormControl className={classes.formControl}>
                    <InputLabel id="demo-simple-select-label">{capitalizeFirstLetter(translateGui(89))}</InputLabel>
                    <Select
                        labelId="demo-simple-select-label"
                        id="demo-simple-select"
                        value={defaultLanguage}
                        onChange={(e) => setDefaultLanguage(e.target.value)}
                        style={{ maxWidth: '300px' }}
                    >

                        {
                            languages.map(
                                lang =>
                                    <MenuItem value={lang.code}>{lang.name}</MenuItem>
                            )
                        }
                    </Select>
                </FormControl>
            </div>

            <div className={classes.flexColumn} style={{ marginTop: '30px' }}>
                {capitalizeFirstLetter(translateGui(90))}
                {
                    languages.map(
                        language => 
                            language.code != defaultLanguage ?
                                <div key={language.code} style={{ display: 'flex', alignItems: 'center' }}>
                                    <Checkbox key={language.code}
                                        onChange={() => checkBoxClicked(language.code)}
                                        checked={availableLanguages.filter(lang => lang == language.code).length > 0}
                                    >
                                    </Checkbox>
                                    {language.name}
                                </div>
                                : null
                        

                    )
                }


            </div>

            <div style={{ display: 'flex', marginTop: '30px' }}>

                {
                    isMultiLangEnabled ?
                        <Button onClick={disableMultiLang} style={{ alignSelf: 'flex-start' }} variant="contained" color="primary">
                            {capitalizeFirstLetter(translateGui(93))}
                        </Button>
                        : null
                }



                <Button onClick={sendToServer} style={{ marginLeft: 'auto' }} variant="contained" color="primary">
                    {
                        isMultiLangEnabled ?
                            <React.Fragment>
                                {capitalizeFirstLetter(translateGui(45))}
                            </React.Fragment>
                            : null
                    }
                    {
                        !isMultiLangEnabled ?
                            <React.Fragment>
                                {capitalizeFirstLetter(translateGui(91))}
                            </React.Fragment>
                            : null
                    }

                </Button>

            </div>

        </div>
    )
}

const useStyles = makeStyles({
    root: {
        maxWidth: '400px',
    },
    tableStyle: {
        '& input': {
            border: 'none',
            borderBottom: '1px solid',
            fontFamily: 'Roboto',
            fontSize: '1rem',
        }
    },
    flexColumn: {
        display: 'flex',
        flexDirection: 'column',


        '& > *': {
            marginTop: '10px',
        }
    },
    marginBottom: {
        marginBottom: '20px',
    },

});